import React from "react";
import { Link } from "react-router-dom";

const RenderBasket = ({ basket }) => {
  return (
    <div className="d-flex justify-content-center">
      {basket && basket.name && (
        <div
          className="px-4 py-2 basket-notif"
          style={{
            position: "fixed",
            bottom: 0,
            zIndex: 10,
            backgroundColor: "#E42A3F",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderTopRightRadius: "10px",
            borderTopLeftRadius: "10px",
            width: "30%",
          }}
        >
          <Link
            to={"/card"}
            style={{
              display: "flex",
              flex: 1,
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div className="d-flex align-items-center justify-content-between">
              <i
                className="fas fa-shopping-cart"
                style={{
                  color: "#fff",
                  marginLeft: 10,
                }}
              ></i>
              <h6
                className="text-center text-white m-0"
                style={{
                  paddingLeft: "20px",
                  marginLeft: "20px",
                }}
              >
                سبد خرید شما
              </h6>
            </div>
          </Link>
        </div>
      )}
    </div>
  );
};
export default RenderBasket;
